<template>
  <v-dialog v-model="dialog" max-width="950px">
    <v-card>
      <v-card-title class="blue darken-3 white--text"> jejejej </v-card-title>

      <v-card-text>
        <div class="container">
          <v-select
            v-model="seleccionado"
            :items="categorias"
            item-text="text"
            :loading="loading_categorias"
            :readonly="loading_categorias"
            dense
            hide-details
            return-object
          />
          <v-text-field
            v-model.number="NOTA_APROBACION"
            type="number"
            :readonly="loading_categorias"
            dense
            hide-details
          />

          <div class="container">
            <v-img lazy-src="https://picsum.photos/id/11/10/6" src="img/image5.png"></v-img>

            <div class="text-center">
              <h3 class="text">
                LA ESCUELA SUPERIOR DE NEGOCIOS “ESAM” EN CONVENIO CON LA UNIVERSIDAD NACIONAL SIGLO XX.
              </h3>
              <h1>CERTIFICA:</h1>
            </div>
            <p>Por la documentación que cursó en nuestro poder, se evidenció:</p>
            <p>
              Que, el {{ datos.artgenero }} {{ datos.prof }} {{ datos.nombre }} con C.I. {{ datos.ci }}, es alumno
              regular de nuestra Institución {{ datos.prefijocate }} <b>{{ datos.categoria }}</b> en
              <b>{{ datos.programa }} </b>, el programa contiene {{ datos.modulos }}, se lleva a cabo 1 módulo por mes,
              a continuación, se detalla los módulos cursados y aprobados:
            </p>

            <v-progress-linear indeterminate v-if="loading_cursos" />

            <template>
              <v-simple-table class="borde">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th colspan="1" rowspan="2" class="borde">MÓDULO</th>
                      <th colspan="2" class="text-center borde">CALIFICACIÓN</th>
                      <th rowspan="2" class="borde">RESULTADO</th>
                    </tr>
                    <tr>
                      <th class="borde text-center">NUMERAL</th>
                      <th class="borde text-center">LITERAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, ind) in xprograma.modulos" :key="ind">
                      <td class="borde">{{ item.name }}</td>
                      <td class="borde text-right">{{ item.numeral }}</td>
                      <td class="borde text-right">{{ item.literal }}</td>
                      <td class="borde text-right">{{ item.resultado }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
          </div>

          <v-btn color="info darken-2" class="ma-2 white--text" @click="generateReport()">
            Descargar certificado de notasDD
            <v-icon right dark> mdi-cloud-download </v-icon>
          </v-btn>
          <v-btn color="red darken-3" class="white--text" @click="dialog = !dialog">
            Cerrar
          </v-btn>
        </div>
      </v-card-text>

      <v-card-actions> </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style type="text/css">
  .borde {
    border: 1px solid black !important;
  }
</style>

<script>
  // import pdfMake from 'pdfmake';
  // import { generar } from './pdfnotas.js';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      NOTA_APROBACION: 101,
      dialog: false,
      datos: {
        //artgenero: 'el',
        //prof: 'Lic.',
        artgenero: '',
        prof: 'Estudiante ',
        nombre: 'Ruben Julio Ponce Vergara',
        ci: '5036550 Tj.',
        prefijocate: 'la ',
        categoria: 'MAESTRÍA',
        programa: 'INVESTIGACIÓN CIENTÍFICA APLICADA',
        modulos: '15 Módulos',
      },
      desserts: [],
      categorias: [],
      loading_categorias: false,
      loading_cursos: false,
      seleccionado: null,
      xprograma: { modulos: [] },
      uname: 'dsaldias',
    }),
    components: {},
    watch: {
      seleccionado: function() {
        this.getNotasByCourse();
      },
      NOTA_APROBACION: function() {
        this.openmodal(this.uname);
      },
    },
    methods: {
      generateReport() {
        this.crearPDF();
      },
      openmodal(uname) {
        this.uname = uname;
        this.dialog = true;
        this.categorias = [];
        this.seleccionado = null;
        this.xprograma.modulos = [];
        this.getByUname();
      },
      literalitox(num) {
        return this.literal(num);
      },
      getresultado(notaf) {
        if (notaf == null || notaf == '') return 'SIN NOTA';
        if (notaf >= this.NOTA_APROBACION) return 'APROBADO';
        else return 'REPROBADO';
      },
      literal(num) {
        const nums = [
          'CERO',
          'UNO',
          'DOS',
          'TRES',
          'CUATRO',
          'CINCO',
          'SEIS',
          'SIETE',
          'OCHO',
          'NUEVE',
          'DIEZ',
          'ONCE',
          'DOCE',
          'TRECE',
          'CATORCE',
          'QUINCE',
          'DIECISEIS',
          'DIECISIETE',
          'DIECIOCHO',
          'DIECINUEVE',
        ];
        const dece = ['VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA', 'CIEN'];
        if (num < 20) return nums[num];
        const decimo = num % 10;
        const digito = parseInt(num / 10);
        if (decimo == 0) return dece[digito - 2];
        else if (digito == 2) return 'VEINTI' + nums[decimo];
        else return dece[digito - 2] + ' Y ' + nums[decimo];
      },
      getByUname() {
        let vue = this;
        this.loading_categorias = true;
        let course_id = this.$route.query.course_id;
        const promise1 = xaxios.get(
          `${process.env.VUE_APP_API_REST_MOODLE}/esam/user/uname/${this.uname}/enrolment/category/course`,
        );
        const promise2 = xaxios.get(`${process.env.VUE_APP_API_REST}/esam/persona/uname/${this.uname}`);
        Promise.all([promise1, promise2])
          .then(function(values) {
            let data = values[0].data;
            let data2 = values[1].data;
            data.categories.map((x) => {
              x.text = `${x.name} [${x.id}]`;
            });
            vue.categorias = data.categories;
            vue.datos.nombre = `${data2.persona.nombres} ${data2.persona.primer_apellido} ${data2.persona.segundo_apellido}`;
            vue.datos.ci = data2.persona.numero_documento;
            vue.datos.prefijocate = '';
            vue.datos.categoria = '';
            vue.datos.programa = '';
            vue.loading_categorias = false;

            // para el select automatico el actual programa
            vue.categorias.forEach((c) => {
              let curso = c.courses.find((x) => x.id == course_id);
              if (curso) {
                let idcategoria = curso.category_id;
                vue.seleccionado = vue.categorias.find((cc) => cc.id == idcategoria);
              }
            });
          })
          .catch((e) => {
            window.console.log(e);
            vue.loading_categorias = false;
          });
      },
      getNotasByCourse() {
        if (!this.seleccionado) return;
        this.loading_cursos = true;
        let vue = this;
        let pe = [];
        vue.xprograma.nombre = this.seleccionado.name;
        vue.datos.programa = this.seleccionado.name;
        vue.datos.modulos = this.seleccionado.courses.length + ' Módulos';
        vue.xprograma.modulos = [];
        let xmods = [];
        this.seleccionado.courses.forEach((x) => {
          pe.push(xaxios.get(`${process.env.VUE_APP_API_REST}/esam/programa/modulo/course/id/${x.id}/inscripcion`));
          xmods.push({ courseid: x.id, name: x.fullname, numeral: 0, literal: '', resultado: '' });
        });

        Promise.all(pe)
          .then(function(values) {
            window.console.log('seleccionado.courses', vue.seleccionado.courses);
            window.console.log('seleccionado.courses', values);
            values.forEach((x) => {
              let modulo = x.data.modulo_inscripciones.find((mi) => mi.username == vue.uname);
              let xpm = xmods.find((pm) => pm.courseid == x.data.course_id);
              if (xpm) {
                xpm.estudiante_id = modulo.estudiante_id;
                xpm.estado_inscripcion = modulo.estado_inscripcion;
                xpm.nota_final = modulo.nota_final;
                xpm.nota_recuperatorio = modulo.nota_recuperatorio;

                xpm.numeral =
                  modulo.nota_final > modulo.nota_recuperatorio ? modulo.nota_final : modulo.nota_recuperatorio;
                xpm.literal = vue.literalitox(xpm.numeral);
                xpm.resultado = vue.getresultado(xpm.numeral);
                window.console.log(modulo);
              }
            });
            vue.xprograma.modulos = xmods;
            window.console.log(vue.xprograma);
            vue.loading_cursos = false;
          })
          .catch((e) => {
            window.console.log(e);
            vue.loading_cursos = false;
          });
      },

      addImageProcess(src) {
        var c = document.createElement('canvas');
        return new Promise((resolve, reject) => {
          let img = new Image();
          img.setAttribute('crossorigin', 'anonymous');
          img.onload = () => {
            c.height = img.naturalHeight;
            c.width = img.naturalWidth;
            var ctx = c.getContext('2d');

            ctx.drawImage(img, 0, 0, c.width, c.height);
            resolve(c.toDataURL());
          };
          img.onerror = reject;
          img.src = src;
        });
      },

      async crearPDF() {
        //let cabecera = await this.addImageProcess('img/cabecera_uajms.webp');
        let cabecera = await this.addImageProcess('img/cabecera_sxx.webp');
        let pie = await this.addImageProcess('img/piepagina.png');
        var dd = {
          header: {
            image: cabecera,
            width: 594,
            height: 120,
            margin: [0, 0, 0, 0],
          },
          footer: function() {
            return {
              table: {
                body: [
                  [
                    { image: pie, alignment: 'center', width: 594, height: 90 },
                    {
                      text: 'MSc. Eva Saavedra Quinteros',
                      alignment: 'center',
                      style: 'normalText',
                      margin: [-594, 34, 0, 0],
                    },
                    { text: 'DIRECTORA NACIONAL', alignment: 'center', style: 'footerbold', margin: [-594, 50, 0, 0] },
                    { text: 'ESAM BOLIVIA', alignment: 'center', style: 'footerbold', margin: [-594, 62, 0, 0] },
                  ],
                ],
              },
              layout: 'noBorders',
            };
          },
          pageMargins: [40, 130, 40, 90],
          content: [
            'First paragraph',
            'Another paragraph, this time a little bit longer to make sure, this line will be divided into at least two lines',
          ],
        };
        window.pdfMake.fonts = {
          Roboto: {
            normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
            bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
            italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
            bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf',
          },
        };
        window.console.log(dd);

        window.pdfMake.createPdf(dd).open();
      },
    },
    mounted() {},
  };
</script>
